import { createAction } from "@reduxjs/toolkit";

enum AuthenticationActionTypes {
    INIT = "[Application] INIT",
    INIT_DONE = "[Application] INIT_DONE",
}

export const initAction = createAction(AuthenticationActionTypes.INIT);
export const initDoneAction = createAction(AuthenticationActionTypes.INIT_DONE);
